import type { ThemeBreakpointTokens } from "@yamada-ui/core"

export const breakpoints: ThemeBreakpointTokens = {
  sm: "30em",
  md: "48em",
  lg: "61em",
  xl: "80em",
  "2xl": "90em",
}
